// ═══════════════════════════════════════════════════════════════════════════════
// Pin Message Schemas
// ═══════════════════════════════════════════════════════════════════════════════
import { z } from 'zod';
import { SUPPORTED_LANGUAGES } from '../constants/index.js';
import { PIN_MESSAGE_ICON, PIN_MESSAGE_VISIBILITY } from '../types/pinMessage.js';
import { dateSchema, uuidSchema } from './common.schema.js';
const optionalDisplayDateSchema = z.union([dateSchema, z.literal('')]);
const pinMessageInputBaseSchema = z.object({
    title: z.string().trim().min(1, 'Title is required').max(300, 'Title too long'),
    content: z.string().trim().min(1, 'Content is required').max(3000, 'Content too long'),
    visibility: z.enum([PIN_MESSAGE_VISIBILITY.EMPLOYER_ONLY, PIN_MESSAGE_VISIBILITY.BOTH]),
    iconType: z.enum([
        PIN_MESSAGE_ICON.INFO,
        PIN_MESSAGE_ICON.REMIND,
        PIN_MESSAGE_ICON.SPECIAL_ALERT,
    ]),
    isActive: z.boolean().default(true),
    displayFromDate: optionalDisplayDateSchema.default(''),
    displayToDate: optionalDisplayDateSchema.default(''),
});
export const createPinMessageInputSchema = pinMessageInputBaseSchema
    .refine((data) => {
    if (data.displayFromDate === '' || data.displayToDate === '') {
        return true;
    }
    return data.displayFromDate <= data.displayToDate;
}, {
    message: 'Display from date must be before or equal to display to date',
    path: ['displayToDate'],
});
export const updatePinMessageInputSchema = pinMessageInputBaseSchema
    .partial()
    .refine((data) => {
    if (data.displayFromDate === undefined || data.displayToDate === undefined) {
        return true;
    }
    if (data.displayFromDate === '' || data.displayToDate === '') {
        return true;
    }
    return data.displayFromDate <= data.displayToDate;
}, {
    message: 'Display from date must be before or equal to display to date',
    path: ['displayToDate'],
});
export const pinMessageIdParamSchema = z.object({
    id: uuidSchema,
});
export const reorderPinMessageInputSchema = z.object({
    orderedIds: z.array(uuidSchema).min(1, 'At least one id is required'),
});
export const pinMessageListQuerySchema = z.object({
    includeInactive: z.enum(['true', 'false']).default('false'),
    /** Helper UI language for lazy translation on list load. */
    viewerLanguage: z.enum(SUPPORTED_LANGUAGES).optional(),
});
//# sourceMappingURL=pinMessage.schema.js.map